import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import DOMPurify from 'dompurify';
import VueMarkdown from 'vue-markdown';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSummary',
  props: {
    title: null,
    tags: null,
    content: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  tags?: string[];
  content?: string;
};



const looksLikeHtml = (value: string) => /<[^>]+>/.test(value);
const isHtmlContent = computed(() => Boolean(props.content && looksLikeHtml(props.content)));

const sanitizedHtmlContent = computed(() =>
  isHtmlContent.value && props.content ? DOMPurify.sanitize(props.content) : ''
);

return { __sfc: true,props, looksLikeHtml, isHtmlContent, sanitizedHtmlContent, VueMarkdown }
}

})